import { Component, OnInit } from '@angular/core';
//import { JOYTOGIVEGA } from '../assets/ga'
import { initGaVars, gaEvents } from '../../assets/js/ga.js';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})


export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // //updateStore("cid", gaVars.cid); // google client id
    // //updateStore("utmString", gaVars.utmString);
    const gaVars = initGaVars()
    console.log('Update GA CID:' + gaVars.cid)
    console.log('Update GA UTMSTRING:' + gaVars.utmString)

    gaEvents('joytogive', 'Joy to Give | World Vision Ph | Landing Page')
  }

}
